<template>
<div>
  <div
    v-show="!calendarOpen && !isMobile"
    class="container-input"
    @click="openCalendar">
    <div style="font-size: 14px">
      <i class="fa-solid fa-calendar-days" />
        &nbsp;&nbsp;
      <strong>DATA</strong>
    </div>
    <div>
      <i v-if="availableDates.length <= 0">Nenhuma data disponível</i>
      <span
        v-else
        style="color: #757575">{{ dataFormatada }}</span>
    </div>
  </div>
  <div v-if="availableDates.length <= 0 && isMobile">
    <i>Nenhuma data disponível</i>
  </div>
  <div
    v-show="availableDates.length > 0 && (calendarOpen || isMobile)"
    style="margin-left: -20px; margin-right: -20px">
    <v-calendar
      translate="no"
      :columns="!isMobile && calendarSize == 2 ? $screens({ default: 1, xsm: 2 }) : 1"
      :rows="!isMobile && calendarSize == 2 ? $screens({ default: 2, xsm: 1 }) : 1"
      :attributes="calendarAttr"
      :available-dates="filteredAvailableDatesParsed"
      :from-date="startDate"
      :min-page="minPage"
      :max-date="maxDateNoAvailability"
      transiton="none"
      is-expanded
      @update:to-page="onCalendarPageUpdate"
      @update:from-page="onCalendarPageUpdate"
      @dayclick="diaSelecionado" />
  </div>
  <div
    v-show="(calendarOpen || isMobile) && monthsLoading > 0"
    style="position: relative; top: -30px; overflow: visible; height: 1px; text-align: right">
    <i class="fa-regular fa-hourglass" />
  </div>
</div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

const dateToString = function (date) {
  const mes = date.toLocaleDateString('pt-BR', { month: '2-digit' });
  const dia = date.toLocaleDateString('pt-BR', { day: '2-digit' });
  const ano = date.toLocaleDateString('pt-BR', { year: 'numeric' });
  return ano + '-' + mes + '-' + dia;
};

export default {
  components: {},
  props: {
    value: {
      validator: v => v instanceof Date || v == null,
      default: () => null,
      required: false
    },
    initialAvailableDays: {
      type: String,
      default: () => '[]',
      required: false
    },
    passeioId: {
      validator: typeof v === 'string' || typeof v === 'number',
      default: () => 0,
      required: false
    },
    isMobile: {
      type: Boolean,
      default: () => false,
      required: false
    },
    calendarSize: {
      type: Number,
      default: () => 2,
      required: true
    },
    startOpened: {
      type: Boolean,
      default: () => false,
      required: false
    },
    minDate: {
      type: Date,
      default: () => null,
      required: false
    },
    isCombo: {
      type: Boolean,
      default: () => false,
      required: false
    }
  },
  emits: ['input', 'on-open-change'],
  data() {
    return {
      calendarOpen: this.startOpened,
      internalDate: null,
      availableDates: JSON.parse(this.$props.initialAvailableDays),
      cachedMonths: [],
      monthsLoading: 0,
      startDate: new Date()
    };
  },
  computed: {
    dataFormatada() {
      if (!this.$props.value) {
        return 'Selecione a data';
      }
      let mes = this.$props.value.toLocaleDateString('pt-BR', { month: 'long' });
      mes = mes[0].toUpperCase() + mes.substring(1);
      const dia = this.$props.value.toLocaleDateString('pt-BR', { day: 'numeric' });
      const year = this.$props.value.toLocaleDateString('pt-BR', { year: 'numeric' });
      const diaSemana = this.$props.value.toLocaleDateString('pt-BR', { weekday: 'long' });
      return dia + ' de ' + mes + ' | ' + year + ' (' + diaSemana + ')';
    },
    calendarAttr() {
      if (!this.$props.value) {
        return [];
      }
      return [
        {
          key: 'selecionado',
          highlight: 'indigo',
          dates: this.$props.value
        }
      ];
    },
    availableDatesParsed() {
      return this.availableDates.map(raw => {
        const parts = raw.split('-');
        return new Date(parts[0], parts[1] - 1, parts[2], 0, 0, 0, 0);
      });
    },
    filteredAvailableDatesParsed() {
      return this.filteredAvailableDates.map(raw => {
        const parts = raw.split('-');
        return new Date(parts[0], parts[1] - 1, parts[2], 0, 0, 0, 0);
      });
    },
    filteredAvailableDates() {
      if (!this.minDate) {
        return this.availableDates;
      }
      return this.availableDates.filter(dateStr => {
        const parts = dateStr.split('-');
        const date = moment(new Date(parts[0], parts[1] - 1, parts[2], 23, 59, 59, 0));
        return date.isSameOrAfter(this.minDate);
      });
    },
    minPage() {
      const now = moment();
      return {
        year: now.year(),
        month: now.month() + 1
      };
    },
    maxDateNoAvailability() {
      if (this.filteredAvailableDates.length == 0) {
        return moment().subtract(1, 'days').toDate();
      }
      return undefined;
    }
  },
  watch: {
    calendarOpen() {
      this.$emit('on-open-change', this.calendarOpen);
    }
  },
  created() {
    if (!this.availableDates || this.availableDates.length <= 0) {
      if (this.isCombo) this.calendarOpen = false;
      return;
    }
    const first = this.availableDates[0];
    const partsFirst = first.split('-');
    this.cachedMonths.push(Number(partsFirst[0]) + '-' + Number(partsFirst[1]));

    const parts = this.availableDates[0].split('-');
    this.startDate = new Date(parts[0], parts[1] - 1, parts[2], 0, 0, 0, 0);
  },
  mounted() {
    this.preSelectDayFromQueryParam();
  },
  methods: {
    openCalendar() {
      if (this.filteredAvailableDates.length <= 0) {
        return;
      }
      this.calendarOpen = true;
    },
    diaSelecionado(evt) {
      if (!this.filteredAvailableDates.includes(dateToString(evt.date))) {
        return;
      }
      this.$emit('input', evt.date);
      this.calendarOpen = false;
    },
    async preSelectDayFromQueryParam() {
      const urlParams = new URLSearchParams(window.location.search);
      const dayFromParams = urlParams.get('day');
      if (!dayFromParams) {
        return;
      }
      const parts = dayFromParams.split('-');
      if (!Array.isArray(parts) || parts.length != 3) {
        return;
      }
      const year = Number(parts[0]);
      const month = Number(parts[1]);
      const day = Number(parts[2]);
      if (year < 1 || month < 1 || day < 1) {
        return;
      }
      const date = new Date(year, month - 1, day);
      if (date < new Date()) {
        return;
      }
      await this.loadMonth(year, month);
      if (!this.filteredAvailableDates.includes(dateToString(date))) {
        return;
      }
      this.$emit('input', date);
      this.calendarOpen = false;
    },
    async onCalendarPageUpdate(evt) {
      const today = new Date();
      if (
        evt.year < today.getFullYear() ||
        (evt.year == today.getFullYear() && evt.month < today.getMonth() + 1)
      ) {
        return;
      }
      await this.loadMonth(evt.year, evt.month);
    },
    async loadMonth(year, month) {
      const cacheKey = Number(year) + '-' + Number(month);
      if (this.cachedMonths.includes(cacheKey)) {
        return;
      }
      this.cachedMonths.push(cacheKey);
      let uri = '?month=' + encodeURIComponent(month) + '&year=' + encodeURIComponent(year);
      this.monthsLoading++;
      try {
        const r = (await axios.get('/disponibilidade/' + this.$props.passeioId + uri)).data;
        if (Array.isArray(r)) {
          const newDates = [];
          r.forEach(date => {
            if (!this.availableDates.includes(date)) {
              newDates.push(date);
            }
          });
          this.availableDates = [...this.availableDates, ...newDates];
        }
      } catch (err) {
        // Empty
      }
      this.monthsLoading--;
    }
  }
};
</script>

<style scoped>
.container-input {
  border: 1px solid #707070;
  border-radius: 5px;
  padding: 15px;
  cursor: pointer;
}
</style>
